module.exports = __webpack_public_path__ + "static/woocommerce_visa-mastercard-12e67ec527843e9e783cadecca9ab22e.svg";